import React, { useEffect } from 'react'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyTextArea from 'app/components/util/lgy-text-area/LgyTextArea'
import MarkDownExample from 'app/gears/admin/announcements/components/MarkDownExample'
import AnnouncementPreviewSection from 'app/gears/admin/announcements/components/AnnouncementPreviewSection'
import DeleteAnnouncementsSection from 'app/gears/admin/announcements/components/DeleteAnnouncementsSection'
import { formatNameCompact } from 'app/utils/userUtils'
import { required, maxLength, minLength } from 'app/utils/validations'
import { createAnnouncement, getAnnouncements, deleteAnnouncement } from 'app/gears/announcements/actions/announcementsActions'

const maxLength4000 = maxLength(4000)
const maxLength100 = maxLength(100)
const minLength10 = minLength(10)

/**
 * A connected form for creating an announcement. Also allows the deletion of announcements.
 * 
 * @author Alex Clary
 * 
 * TODO: Maybe this should be split up more?
 * TODO: Add announcement editing
 * TODO: Add a date range for when an announcement should be displayed so it can be queued up in advance
 */
let AnnouncementsForm = ({ getAnnouncements, deleteAnnouncement, announcements, formValues, pristine, submitting, submitFailed, submitSucceeded, reset, handleSubmit, error, dirty }) => {
  useEffect(
    () => {
      console.log('Mounted, getting announcements')
      getAnnouncements()
    },
    [getAnnouncements]
  )
  return <form id='admin-announcements-form' onSubmit={handleSubmit}>
    <header>
      <h2>Manage Announcements</h2>
      <p>Use this form to create and delete announcements. Announcements are posts that are visible to all users in the gearbox. </p>
      <p>Markdown syntax is supported for the announcement body. Learn more about markdown syntax <a href='https://www.markdownguide.org/basic-syntax/'>here.</a></p>
      <MarkDownExample />
    </header>
    {submitSucceeded && <LgyAlertDialog type='success' heading='Announcement Created' text='Announcement created successfully' />}
    {error && <LgyAlertDialog type='error' heading='Submission Failed' text={error} />}
    <Field
      name='headline'
      component={LgyInputField}
      label='Announcement Headline'
      placeholder='e.g. "Welcome to LGYHub"'
      validate={[required, minLength10, maxLength100]}
      required
    />
    <Field
      name='author'
      component={LgyInputField}
      label='Author'
      placeholder='Author'
      validate={[required, maxLength100]}
      required
    />
    <Field
      name='body'
      component={LgyTextArea}
      label='Announcement Body'
      placeholder='Use ordinary plaintext, or if desired, markdown syntax here'
      validate={[required, minLength10, maxLength4000]}
      required
    />

    <LgyFormSubmit pristine={pristine} submitting={submitting} submitFailed={submitFailed} submitSucceeded={submitSucceeded} error={error} reset={reset} />
    {dirty && <AnnouncementPreviewSection formValues={formValues} />}
    <DeleteAnnouncementsSection announcements={announcements} deleteAnnouncement={deleteAnnouncement} />
  </form >

}
AnnouncementsForm = reduxForm({ form: 'announcementsForm' })(AnnouncementsForm)

const mapStateToProps = (state, ownProps) => ({
  formValues: getFormValues('announcementsForm')(state),
  announcements: state.announcementsState.announcements,
  initialValues: {
    author: formatNameCompact(state.currentUser)
  }
})

const mapDispatchToProps = {
  getAnnouncements,
  deleteAnnouncement,
  onSubmit: createAnnouncement
}

AnnouncementsForm = connect(mapStateToProps, mapDispatchToProps)(AnnouncementsForm)

export default AnnouncementsForm